(function () {
  'use strict';
  // Percentage offers and their size. The backend names the offer:
  // rewardOfferArm for guests, datesReward.arm for members (pct10 from
  // 12 Oct 2026; issued pct30 codes keep 30%).
  var PCT = { pct30: 30, pct10: 10 };
  function percentOf(arm) { return typeof arm === 'string' && Object.prototype.hasOwnProperty.call(PCT, arm) ? PCT[arm] : null; }

  /* The bar's line for a /me answer, or null to keep the neutral server copy
     (no answer, or a guest answer that names no known offer). Pure. */
  function copyFor(me) {
    if (!me || typeof me.signedIn !== 'boolean') return null;
    var member = me.signedIn && me.member;
    if (member) {
      var reward = member.datesReward;
      if (reward && typeof reward.arm === 'string' && reward.arm && !percentOf(reward.arm) && reward.arm !== 'free_delivery' && reward.arm !== 'none' && reward.arm !== 'off') {
        return { state: 'member', label: 'Make room for the people who matter.', detail: 'View reminders', short: 'View your reminders' };
      }
      var ready = reward && reward.status === 'earned' && /^REMIND-[A-Za-z0-9]{4,32}$/.test(reward.code || '') && (!reward.expiresAt || Date.parse(reward.expiresAt) > Date.now());
      var pending = !!(reward && reward.status === 'pending');
      var readyLabel = percentOf(reward && reward.arm) ? 'Your ' + percentOf(reward.arm) + '% off is ready' : 'Your free delivery is ready';
      return {
        state: ready ? 'ready' : pending ? 'pending' : 'member',
        label: ready ? readyLabel + '.' : pending ? 'Your reminder reward is on its way.' : 'Make room for the people who matter.',
        detail: ready || pending ? 'View my reward' : 'View reminders',
        // Phones: one line, message and link together (assets/announcement-bar.css).
        short: ready ? readyLabel : pending ? 'Your reward is on its way' : 'View your reminders'
      };
    }
    if (me.signedIn) return null;
    if (Object.prototype.hasOwnProperty.call(me, 'rewardOfferArm') && (me.rewardOfferArm === null || me.rewardOfferArm === 'none' || me.rewardOfferArm === 'off')) return { state: 'neutral' };
    var percent = percentOf(me.rewardOfferArm);
    return percent ? { state: 'offer', label: percent + '% off your first order.', detail: 'Add 3 dates', short: 'Add 3 dates for ' + percent + '% off' } : null;
  }

  /* The pre-seed landing is the only reminders view that hides this bar.
     A normal reminders page, and every other page, keeps it. */
  function announcementHiddenOnPreseed(search) {
    var view = '';
    try {
      var params = new URLSearchParams(String(search || ''));
      view = params.get('reminder_view') || params.get('view') || '';
    } catch (e) { view = ''; }
    return view === 'preseed';
  }

  function init() {
    var bar = document.querySelector('[data-fb-persistent-announcement]');
    if (!bar || bar.dataset.pinned) return;
    if (announcementHiddenOnPreseed(window.location && window.location.search)) {
      bar.hidden = true;
      if (bar.parentElement) bar.parentElement.hidden = true;
      if (document.documentElement && document.documentElement.setAttribute) document.documentElement.setAttribute('data-fb-preseed-view', '1');
      return;
    }
    var spacer = bar.parentElement;
    // Retain the live server copy so a disabled offer can reset an earlier one.
    var neutral = {
      label: bar.querySelector('[data-fb-persistent-message]').textContent,
      detail: bar.querySelector('[data-fb-persistent-detail]').textContent,
      short: bar.querySelector('[data-fb-persistent-short]').textContent
    };
    function measure() {
      var height = bar.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--fb-announcement-height', height + 'px');
      spacer.style.height = height + 'px';
    }
    measure(); bar.dataset.pinned = 'true';
    if (typeof ResizeObserver === 'function') new ResizeObserver(measure).observe(bar);
    else window.addEventListener('resize', measure);
    function apply(me) {
      var copy = copyFor(me);
      // No usable answer (a /me error, a signed-out answer without an offer):
      // keep whatever is on screen, the neutral line until a real answer.
      if (!copy) return;
      if (copy.state === 'neutral') copy = Object.assign({ state: copy.state }, neutral);
      var label = bar.querySelector('[data-fb-persistent-message]');
      var detail = bar.querySelector('[data-fb-persistent-detail]');
      var short = bar.querySelector('[data-fb-persistent-short]');
      label.textContent = copy.label;
      detail.textContent = copy.detail;
      if (short) short.textContent = copy.short;
      bar.dataset.fbPersistentState = copy.state;
      measure();
    }
    function update(event) { apply(event.detail && event.detail.me); }
    document.addEventListener('fb-reminders:me', update);
    document.addEventListener('fb-reminders:state', update);
    // An accepted answer this page already has, else the fresh cache that
    // sections/announcement-bar.liquid read before first paint.
    if (window.FBRemindersCurrentMe) apply(window.FBRemindersCurrentMe.me);
    else if (window.FBRemindersCachedMe) apply(window.FBRemindersCachedMe);
  }
  if (typeof module === 'object' && module && module.exports) {
    module.exports.copyFor = copyFor;
    module.exports.announcementHiddenOnPreseed = announcementHiddenOnPreseed;
  }
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
